const metaData = {
  fields: [
    'id',
    'test_track_id',
    'paper_id',
    'test_event_id',
    'product_id',
    'slot_assigned',
    { paper: ['id', 'paper_id', 'paper_smart_id', 'parent_paper_id','name', { variant_papers: ['id', 'paper_id', 'paper_smart_id'] }] },
    { test_track: ['id', 'name'] },
    { test_event: ['id', 'name', 'slots', 'product_id'] },
  ],
}

export default metaData
